(ns app.front.view.application.delete
  (:require [app.front.dashlets :as dashlets]
            [app.front.process :as process]
            [re-frame.core-instrumented :as rf]))


;;
;; Delete application
;;

(rf/reg-event-fx ::delete-application.success
  ;; `::process/signal` has already applied the db changes carried by the response.
  (fn [{:keys [db]} [_ application _status _db-changes]]
    (let [user        (-> db :session/user)
          app-dash-id (str (:db/id user) "-my-applications")]
      {:dispatch-n [[::dashlets/delete-item app-dash-id (-> application :db/id)]
                    [:notifications/add
                     :inline
                     :success
                     :delete.application/success
                     :delete.application/deleted]]
       :route/push (if-let [licence (-> application :entity/parent :licence/_workspaces first)]
                     ;; if workspace is related to licence, redirect to licence page
                     {:route :view/licence :params {:group-id   (-> licence :domain/authority-group :group/id)
                                                    :licence-id (:licence/id licence)}}
                     ;; otherwise, back to dashboard
                     :dashboard)})))


(rf/reg-event-fx ::delete-application
  (fn [_ [_ application]]
    {:dispatch [::process/signal
                application
                [:process.signal/delete]
                {:on-success [::delete-application.success application]}]}))


;; delete draft (during pre-consultation)
(rf/reg-event-fx ::delete-application-draft.success
  (fn [_ [_ workspace-id]]
    {:fx [[:route/replace {:route :view/workspace :params {:workspace-id workspace-id}}]]}))

(rf/reg-event-fx ::delete-application-draft
  (fn [_ [_ application]]
    {:dispatch [::process/signal
                application
                [:process.signal/delete-application-only]
                {:on-success [::delete-application-draft.success (-> application
                                                                     :entity/parent
                                                                     :workspace/id)]}]}))
